
import React from 'react';
import {
	Modal,
	ModalBody,
    // ModalFooter,
    // Spinner
} from 'reactstrap';
// import Spinner from 'react-bootstrap/Spinner'
import LoadingSpinnerSmallNew from './LoadingSpinnerSmallNew'

const LoadingNew = ({
	confirmIsOpen,
	// confirmCloseNative, 
	confirmClose, }) => {
	return (
		<Modal className="modal-loading align-items-center justify-content-center" backdrop="static" size='sm' isOpen={confirmIsOpen} toggle={() => confirmClose()}>
			<ModalBody className="align-self-center">
				<div className="ml-2 mb-2">
                    <LoadingSpinnerSmallNew/>
				</div>
				<div className="ml-2 text-center">
				<label className="label-loading-spinner-otp-1" >
						Mohon menunggu ya ... 
                    </label>
					<label className="label-loading-spinner-otp-2" >
						Permintaan Anda sedang diproses
                    </label>
				</div>
			</ModalBody>
		</Modal>
	);
}

export default LoadingNew
